import autosize from "autosize";

$(function () {
  $(document)
    .on("click", "section.collapsed:not(.opened) > .section-title", onOpen)
    .on("click", "section.collapsed.opened > .section-title", onClose);
});

// Bound outside the ready callback: jQuery 3 runs ready callbacks once DOMContentLoaded has already
// fired, so a handler bound there would never run.
document.addEventListener("DOMContentLoaded", function () {
  if (window.location.hash === "") return;
  // id must be valid (not start with a number)
  if (!/#[a-z]/.test(window.location.hash)) {
    return;
  }

  const collapsedEl = document.querySelector(window.location.hash);

  if (collapsedEl?.classList.contains("collapsed")) {
    collapsedEl.classList.add("opened");
  }
});

function onOpen(e) {
  let $e = $(e.target).closest(".collapsed");
  if ($e.hasClass("exclusive-collapse")) {
    $(".collapsed").removeClass("opened");
  }
  $e.addClass("opened");
  $e.trigger("collapsed-opened");
  autosize.update($e.find(".autoresize"));
}

function onClose(e) {
  let $e = $(e.target).closest(".collapsed");
  $e.removeClass("opened");
  $e.trigger("collapsed-closed");
}
